import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_document_hdr_attachment_flow_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_document_hdr_guid: fromDatatype.GuidDataFieldInterface;
  file_guid: fromDatatype.GuidDataFieldInterface;
  file_name: fromDatatype.VarcharDatatypeInterface;
  file_size: fromDatatype.NumericDatatypeInterface;
  file_details: fromDatatype.VarcharDatatypeInterface;
  import_format: fromDatatype.VarcharDatatypeInterface;
  upload_date: fromDatatype.TimestampTzDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  url_key: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.NumericDatatypeInterface;
  process_status: fromDatatype.VarcharDatatypeInterface;
  error_message: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_claim_document_hdr_attachment_flow_RowClass implements bl_aat_claim_document_hdr_attachment_flow_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_document_hdr_guid: fromDatatype.GuidDataFieldInterface;
  file_guid: fromDatatype.GuidDataFieldInterface;
  file_name: fromDatatype.VarcharDatatypeInterface;
  file_size: fromDatatype.NumericDatatypeInterface;
  file_details: fromDatatype.VarcharDatatypeInterface;
  import_format: fromDatatype.VarcharDatatypeInterface;
  upload_date: fromDatatype.TimestampTzDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  url_key: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.NumericDatatypeInterface;
  process_status: fromDatatype.VarcharDatatypeInterface;
  error_message: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
